import { InvoiceStatus, type InvoiceStatusTag } from './types'

export const getInvoiceStatusTag = (
  status: InvoiceStatus,
  t: (key: string) => string
): InvoiceStatusTag => {
  switch (status) {
    case InvoiceStatus.PAID:
      return { state: 'success', label: t('billing.paid') }
    case InvoiceStatus.UNPAID:
      return { state: 'warning', label: t('billing.unpaid') }
  }
}

export const formatCurrency = (amount: number, _currency: string): string => {
  return `$${amount.toFixed(2)}`
}
